import {
    Typography,
    styled,
    Box,
    FormControlLabel,
    Radio,
    Button,
} from "@mui/material";


export const FormLabelTypography = styled(Typography)({
    color: "#404585",
    fontFamily: "Figtree,sans-serif !important",
    fontWeight: "600",
    fontSize: "16px",
});

export const RadioInputBoxes = styled(Box)({
    display: "flex",
    alignItems: "center",
    border: "1px solid #E7E7FF",
    borderRadius: "8px",
    padding: "0.25rem 1rem",
});

export const StyledFormControl = styled(FormControlLabel)({
    marginBottom: "0px",
});

export const StyledRadio = styled(Radio)({
    color: "#376AFA",
    "&.Mui-checked": {
        color: "#376AFA"
    }
});

export const CustomButton = styled(Button)({
    width: "100%",
    height: "2.5rem",
    border: "1px solid #D6D8E5",
    textTransform: "capitalize",
    fontSize: "16px",
});

export const CustomButtonWithoutBorder = styled(Button)({
    width: "100%",
    height: "2.5rem",
    textTransform: "capitalize",
    fontSize: "16px",
});